// Pure console-nav entitlement logic — extracted from Layout so it can be unit-tested.
//
// Rules (see Layout.jsx):
//   • Admin / internal staff  → see the WHOLE console (every item), always.
//   • Core items (no `service`/`services` tag) → always visible to everyone.
//   • Per-service items → visible only when the workspace has ACTIVATED that service
//     (`service` = one key, or `services` = any-of array).
//   • While services are still loading (gateReady=false, non-admin) → hide tagged
//     items (show core only) so there's no flash of forbidden surfaces.
//   • If the services fetch errored (activeServices=null, gateReady=true) → fail OPEN
//     (show everything) so a paid surface is never wrongly hidden.

/** Should one nav item be shown, given the viewer's context? */
export function isEntitled(item, { isAdmin, activeServices, gateReady } = {}) {
  if (isAdmin) return true                                   // internal/admin — full console
  const reqd = item.service ? [item.service] : (item.services || null)
  if (!reqd) return true                                     // core — always
  if (!gateReady) return false                               // loading → core only
  if (!activeServices) return true                           // errored → fail open
  return reqd.some((s) => activeServices.has(s))             // gated to activated services
}

/** Filter grouped nav to the items the viewer is entitled to; drop empty groups. */
export function filterNavGroups(navGroups, ctx = {}) {
  return (navGroups || [])
    .map((g) => ({ ...g, items: (g.items || []).filter((it) => isEntitled(it, ctx)) }))
    .filter((g) => g.items.length > 0)
}
